import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";
import { OrganizationUISettings } from "../../../model/OrganizationUISettings";

export const UPSERT_UI_SETTINGS = "ORGANIZATION:UPSERT_UI_SETTINGS";

export interface UpsertUISettingsAction extends Action {
  type: typeof UPSERT_UI_SETTINGS;
  organization: OrganizationKeyName;
  data: OrganizationUISettings;
}

export const upsertUISettings = (
  organization: OrganizationKeyName,
  data: OrganizationUISettings
): UpsertUISettingsAction => ({
  type: UPSERT_UI_SETTINGS,
  organization,
  data,
});
